import { Link, useLocation } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Menu, X } from "lucide-react";
import { useState } from "react";
import amxLogo from "@/assets/amx-logo-light.svg";

const Navigation = () => {
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(false);

  const isActive = (path: string) => location.pathname === path;

  return (
    <nav className="sticky top-0 z-50 bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60 border-b-2 border-foreground">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <Link to="/" className="hover:opacity-80 transition-opacity">
            <img src={amxLogo} alt="AMX Ventures" className="h-8 w-auto" />
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center gap-8">
            <Link to="/portfolio" className={`text-sm font-bold uppercase tracking-wider transition-colors ${isActive("/portfolio") || location.pathname.startsWith("/portfolio/") ? "text-accent" : "text-foreground hover:text-accent"}`}>Portfolio</Link>
            <Link to="/blog" className={`text-sm font-bold uppercase tracking-wider transition-colors ${isActive("/blog") || location.pathname.startsWith("/blog/") ? "text-accent" : "text-foreground hover:text-accent"}`}>Blog</Link>
            <Link to="/case-studies" className={`text-sm font-bold uppercase tracking-wider transition-colors ${isActive("/case-studies") ? "text-accent" : "text-foreground hover:text-accent"}`}>Case Studies</Link>
            <Link to="/faq" className={`text-sm font-bold uppercase tracking-wider transition-colors ${isActive("/faq") ? "text-accent" : "text-foreground hover:text-accent"}`}>FAQ</Link>
            <Button asChild variant="default" className="font-bold"><Link to="/schedule">Schedule Meeting</Link></Button>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsOpen(!isOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center border-2 border-foreground hover:bg-foreground hover:text-background transition-colors"
            aria-label="Toggle menu"
          >
            {isOpen ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isOpen && (
          <div className="md:hidden py-4 border-t-2 border-foreground">
            <div className="flex flex-col gap-4">
              <Link to="/portfolio" onClick={() => setIsOpen(false)} className={`text-sm font-bold uppercase tracking-wider transition-colors ${isActive("/portfolio") || location.pathname.startsWith("/portfolio/") ? "text-accent" : "text-foreground hover:text-accent"}`}>Portfolio</Link>
              <Link to="/blog" onClick={() => setIsOpen(false)} className={`text-sm font-bold uppercase tracking-wider transition-colors ${isActive("/blog") || location.pathname.startsWith("/blog/") ? "text-accent" : "text-foreground hover:text-accent"}`}>Blog</Link>
              <Link to="/case-studies" onClick={() => setIsOpen(false)} className={`text-sm font-bold uppercase tracking-wider transition-colors ${isActive("/case-studies") ? "text-accent" : "text-foreground hover:text-accent"}`}>Case Studies</Link>
              <Link to="/faq" onClick={() => setIsOpen(false)} className={`text-sm font-bold uppercase tracking-wider transition-colors ${isActive("/faq") ? "text-accent" : "text-foreground hover:text-accent"}`}>FAQ</Link>
              <Button asChild variant="default" className="font-bold w-full" onClick={() => setIsOpen(false)}><Link to="/schedule">Schedule Meeting</Link></Button>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navigation;
